<template>  
  <v-card class="m-5 ma-1 artcard" >
        <v-card-media 
          :gradient="gradient"
          dark @click="toArtefact1(artefact._id)"
          class="white--text cardCursor"
          height="200px"
          :src="artefact.mainImg[0].url+'_card'
          ">
          
          <v-container class="grayoverlay" fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 style="text-align:left">
                 <span class="body-1 white--text" style="text-align:left; white-space:nowrap" ><v-icon  class="body-1 white--text">view_carousel</v-icon> Added at {{artefact.meta.creationDate | date}} </span>
                 <span v-if="showStatus==true">Status: {{getStatus(artefact)}} </span>
              </v-flex>
              <v-flex xs12 align-end> <a @click="toArtefact(artefact._id) " style="text-decoration:none; color:white;  cursor:pointer"><p class="headline mb-1 ml-1">{{artefact.title[lang].slice(0,40).toUpperCase()}} <span v-if="artefact.title[lang].length >40">...</span></p></a></v-flex>
            </v-layout>
          </v-container>
        </v-card-media>
        <v-card-title  style="min-height: 100px;" class="pa-0 collection-list-ie">




          <v-list three-line style="background:transparent" >
            <v-list-tile  avatar style="background:transparent"   >
                            <v-list-tile-avatar v-if="artefactUser&&artefactUser.picture">
                              <img v-if="artefactUser.picture.url" :src="artefactUser.picture.url+'_profile'" >
                              <img v-else :src="artefactUser.picture" >
                            </v-list-tile-avatar>
                            <v-list-tile-avatar v-else >
                              <img src="../../assets/user-icon.png" alt="" class="avatarImg1">
                            </v-list-tile-avatar>
                            <v-list-tile-content dark >
                              <!-- <v-list-tile-title style="color:white" v-html="user.displayName"></v-list-tile-title> -->
                              <v-list-tile-sub-title > {{artefact.description[lang]}} </v-list-tile-sub-title>
                             
                            </v-list-tile-content>
                          </v-list-tile>
          </v-list>
          
        </v-card-title>




        
      </v-card>

</template>


<script>
import { VclFacebook, VclInstagram } from "vue-content-loading";
export default {
	props: ["artefact", "showStatus", "clickImage"],
	data() {
		return {
			loading: false,
			gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)"
		};
	},
	methods: {
		getStatus(artefact) {
			if (artefact.reviewed && !artefact.deleted) return "Published";
			else if (artefact.reviewed && artefact.deleted) return "Waiting for delete review";
			else return "Waiting for publish review";
		},
		toArtefact(artefactID) {
			this.$router.push("/artefacts/" + artefactID);
			window.innerWidth;
		},
		toArtefact1(artefactID) {
			if (this.clickImage != false) this.$router.push("/artefacts/" + artefactID);
			else if (window.innerWidth > 950) {
				this.$router.push("/artefacts/" + artefactID);
			}
		}
	},
	computed: {
		lang() {
			return this.$store.getters.loadLang;
		},
		user() {
			return this.$store.getters.getUser;
		},
		artefactUser() {
			return this.$store.getters.loadSingleUser(this.artefact.userId);
		}
	},
	components: {
		VclFacebook,
		VclInstagram
	}
};
</script>


<style scoped>
.overlay {
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.collection-list-ie {
		display: inline;
	}
}

@media screen and (min-width: 950px) {
	.cardCursor:hover {
		cursor: pointer;
	}
	.artcard:hover {
		transform: scale(1.015);
	}
	.artcard {
		transition: all 0.5s;
	}

	.grayoverlay {
		background-color: rgba(0, 0, 0, 0.5);
		transition: all 0.5s;
	}
	.grayoverlay:hover {
		background-color: rgba(0, 0, 0, 0.2);
	}
}
/* .card__media__background:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to bottom right,#000000,#000000);
  opacity: .7; 
  } */
.headline {
	position: absolute;
	bottom: 3%;
	left: 3%;
}

.avatar2 {
	width: 44px;
	height: 44px;

	border: 12px solid white;
}

.avatarImg1 {
	width: 44px !important;
	height: 44px;
}
</style> 


// WEBPACK FOOTER //
// src/components/Partials/ArtefactCard.vue